module.exports = __webpack_public_path__ + "static/media/default_cover_image.222ca0c3.png";